<ion-label>
  <div class="asset-breadcrumb">
    <span class="asset-breadcrumb--item" (click)="goToFacility()">{{facility.Name}}</span>
    <span *ngFor="let item of assetPath" class="asset-breadcrumb--item" (click)="goToAsset(item)" [class.selected]="assetId == item.Id">
      {{item.Description}}
    </span>
  </div>
</ion-label>